"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._t = void 0;
const i18next_1 = __importDefault(require("i18next"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const react_i18next_1 = require("react-i18next");
const helpers_1 = require("@hip/helpers");
const bq_en_json_1 = __importDefault(require("./languages/bq-en.json"));
const ie_en_json_1 = __importDefault(require("./languages/ie-en.json"));
const resources = {
    BQUK: {
        en: {
            translation: bq_en_json_1.default,
        },
    },
    BQIE: {
        en: {
            translation: ie_en_json_1.default,
        },
    },
    TPUK: {
        en: {
            translation: bq_en_json_1.default,
        },
    },
};
const _t = (key, params = null) => i18next_1.default.t(key, params);
exports._t = _t;
const initTranlations = async (opco) => {
    await i18next_1.default
        // detect user language - learn more: https://github.com/i18next/i18next-browser-languageDetector
        .use(i18next_browser_languagedetector_1.default)
        // pass the i18n instance to react-i18next.
        .use(react_i18next_1.initReactI18next)
        // init i18next - for all options read: https://www.i18next.com/overview/configuration-options
        .init({
        fallbackLng: ['en', 'ro'],
        // @ts-ignore
        resources: resources[opco],
        debug: !(0, helpers_1.isProd)(),
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });
    return i18next_1.default.language;
};
exports.default = initTranlations;
